const handleFetchWorkerPromotionList = (state, action) => {
  state.status = 'succeeded';
  const workerPromotionData = action.payload.data.data || [];
  const paginationInfo = action.payload.data;

  if (workerPromotionData.length > 0) {
    state.workerPromotionList = workerPromotionData; 
    state.currentPageWorkerPromotion = paginationInfo.current_page || 1; 
    state.perPageWorkerPromotion = paginationInfo.limit || 1; 
    state.totalPagesWorkerPromotion = paginationInfo.total_pages || 0; 
    state.totalWorkerPromotions = paginationInfo.total_count || 0; 
    state.lastUpdatedWorkerPromotion = paginationInfo.last_updated || '';
  } else {
    state.workerPromotionList = [];
    state.currentPageWorkerPromotion = 1; 
    state.perPageWorkerPromotion = 1; 
    state.totalPagesWorkerPromotion = 0; 
    state.totalWorkerPromotions = 0; 
    state.lastUpdatedWorkerPromotion = ''; 
  }
};

const handleFetchPromotionList = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
  const promotionData = action?.payload?.data?.data || [];
  const paginationInfo = action?.payload?.data;

  if (promotionData.length > 0) {
    state.promotionList = promotionData; 
    state.currentPagePromotion = paginationInfo.current_page || 1; 
    state.perPagePromotion = paginationInfo.limit || 1; 
    state.totalPagesPromotion = paginationInfo.total_pages || 0; 
    state.totalPromotions = paginationInfo.total_count || 0; 
    state.lastUpdatedPromotion = paginationInfo.last_updated || '';
  } else {
    state.promotionList = []; 
    state.currentPagePromotion = 1; 
    state.perPagePromotion = 1; 
    state.totalPagesPromotion = 0; 
    state.totalPromotions = 0; 
    state.lastUpdatedPromotion = ''; 
  }
};

const handleSavePromotionFulfilled = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
  state.promotionList = state.promotionList.map((promotion) => {
    if (promotion.id === action.payload?.data?.data?.id) {
      return action.payload.data.data;
    }
    return promotion;
  });
};

const handleSaveWorkerPromotionFulfilled = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
  state.workerPromotionList = state.workerPromotionList.map((promotion) => {
    if (promotion.id === action.payload?.data?.id) {
      return action.payload.data;
    }
    return promotion;
  });
};

const handleConditionalItemDirectHire = (state, action) => {
  state.status = 'succeeded';
  state.conditionItemDirectHire = action.payload.data;
};

const handleConditionalItemDirectHireSave = (state) => {
  state.status = 'succeeded';
};

const handleConditionalIteLocalSave = (state, action) => {
  state.status = 'succeeded';
  
  const finalArray = action.payload.data.final_arr;

  state.conditionItemLocalList = state.conditionItemLocalList.map(localItem => {
    const matchingItem = finalArray.find(
      item => item.nationality_id === localItem.nationality_id
    );

    if (matchingItem) {
      const updatedContractCategoryModel = localItem.contractCategoryModel.map(localCategory => {
        const matchingCategory = matchingItem.contractCategoryModel.find(
          cat => cat.contract_category_id === localCategory.contract_category_id
        );

        if (matchingCategory) {
          const updatedContractTypes = localCategory.contractTypes.map(localType => {
            const matchingType = matchingCategory.contractTypes.find(
              type => (localType.id && type.id === localType.id) || 
                     (localType.contract_type && type.contract_type === localType.contract_type)
            );

            if (matchingType && matchingType.amount !== undefined) {
              return {
                ...localType,
                amount: matchingType.amount,
                updated_by: matchingType.updated_by,
                updated_at: matchingType.updated_at
              };
            }
            
            return localType;
          });

          return {
            ...localCategory,
            contractTypes: updatedContractTypes
          };
        }

        return localCategory;
      });

      return {
        ...localItem,
        contractCategoryModel: updatedContractCategoryModel
      };
    }

    return localItem;
  });
};

const handleFixedItemSaveFulfilled = (state) => {
  state.status = 'succeeded';
}

const handleConditionalItemSaveFulfilled = (state) => {
  state.status = 'succeeded';
}

const handleConditionalItemLocalList = (state, action) => {
  state.status = 'succeeded';
  state.conditionItemLocalList = action.payload.data;
};

const handleConditionalItemOverseasList = (state, action) => {
  state.status = 'succeeded';
  state.conditionItemOverseasList = action.payload.data;
};

const handleFixedItemsListFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.fixedItems = action.payload.data;
};

const handleFixedItemsListByTypeFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.fixedItemsListByType = action.payload.data;
}

export {
  handleFetchPromotionList,
  handleSavePromotionFulfilled,
  handleFetchWorkerPromotionList,
  handleSaveWorkerPromotionFulfilled,
  handleConditionalItemDirectHire,
  handleConditionalItemLocalList,
  handleConditionalItemOverseasList,
  handleConditionalItemDirectHireSave,
  handleConditionalIteLocalSave,
  handleFixedItemsListFulfilled,
  handleFixedItemSaveFulfilled,
  handleFixedItemsListByTypeFulfilled,
  handleConditionalItemSaveFulfilled,
};